import { addActiveAssessment } from "../../actions/assessment.action"
import CONFIG from "../../config"
import { SUCCESS } from "../../shared/constants/messages.constants"
import * as FlashMessage from "../../shared/utils/flashMessage"

export const onResumeAssessment = (data = {}) => {
  FlashMessage.success(SUCCESS.RESUME_ASSESSMENT_SUCCESSFULLY)

  CONFIG.Store.dispatch(addActiveAssessment(data))
}